import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FORCE_CB_PAYMENT } from '../../constants/paymentMethods';
import { FUNNEL_PAYMENT_SELECTION_STEP } from '../../constants/funnel';
import { HAS_INSTANT_DISCOUNT, USE_PARITY } from '../../constants/ebon';

import {
    doUserCartTotalCashbackAmount,
    doUserCartTotalCashbackAmountParity
} from '../../utils/cartUtils';
import { formatAmountCurrency, formatAmountParity } from '../../utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import ButtonContainer from './buttons/ButtonContainer';

import './FunnelRightContainerStyle.scss';

const FunnelRightContainer = ({
    partnerId,
    userInfo,
    userCart,
    stateOfTransaction,
    setStateOfTransaction,
    amountCashback,
    cartTotalValue,
    paymentType,
    kycNeeded,
    i18n
}) => {
    const getLabelText = () => {
        if (HAS_INSTANT_DISCOUNT) {
            return convertHtmlToReactDomWithParams(i18n.EBON_CAGNOTTE_INSTANT_DISCOUNT);
        } else {
            return convertHtmlToReactDomWithParams(i18n.EBON_CAGNOTTE);
        }
    };

    return (
        <div id="funnel-right-container">
            <h3>{`${i18n.RECAPITULATIF}`}</h3>
            <div className="rightInnerContainer bordered ebonRecap">
                <p className="cart">{i18n.CART}</p>
                {userCart.map((ebons, i) => (
                    <div key={i}>
                        <p>
                            {convertHtmlToReactDomWithParams(
                                i18n.BON_ACHAT_LIGNE,
                                ebons.partnerName,
                                formatAmountCurrency(ebons.value)
                            )}
                        </p>
                        <div style={{ minWidth: '100px' }}>
                            <span>x {ebons.quantity}</span> <span> = </span>{' '}
                            <span
                                style={{
                                    justifyContent: 'flex-end',
                                    flex: 2
                                }}>
                                {formatAmountCurrency(ebons.quantity * ebons.value)}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            {userInfo && userInfo.firstname && (
                <div className="rightInnerContainer bordered-no-top billing-address">
                    <p>{i18n.ADRESSE}</p>
                    <div className="address-row">
                        {`${typeof userInfo.firstname !== 'undefined' ? userInfo.firstname : ''} ${
                            typeof userInfo.lastname !== 'undefined' ? userInfo.lastname : ''
                        }`}
                    </div>
                    <div className="address-row">
                        {`${
                            typeof userInfo.billingAdress !== 'undefined'
                                ? userInfo.billingAdress.toUpperCase()
                                : ''
                        }`}
                    </div>
                    <div className="address-row">
                        {`${
                            typeof userInfo.billingPostalCode !== 'undefined'
                                ? userInfo.billingPostalCode
                                : ''
                        } ${
                            typeof userInfo.billingCity !== 'undefined'
                                ? userInfo.billingCity.toUpperCase()
                                : ''
                        }`}
                    </div>
                </div>
            )}

            <div className="rightInnerContainer bordered-no-top ebonTotal">
                <div className="cashback">
                    <p>{getLabelText()}</p>
                    <div>
                        <span>
                            {USE_PARITY
                                ? formatAmountParity(
                                      doUserCartTotalCashbackAmountParity(userCart, amountCashback)
                                  )
                                : formatAmountCurrency(
                                      doUserCartTotalCashbackAmount(userCart, amountCashback)
                                  )}
                        </span>
                    </div>
                </div>
                <div className="total">
                    <p>{`${i18n.TOTAL_VALUE}`}</p>
                    <div>
                        <span>{formatAmountCurrency(cartTotalValue)}</span>
                    </div>
                </div>
            </div>

            {stateOfTransaction === FUNNEL_PAYMENT_SELECTION_STEP && !FORCE_CB_PAYMENT && (
                <ButtonContainer
                    paymentType={paymentType}
                    setStateOfTransaction={setStateOfTransaction}
                    cartTotalValue={cartTotalValue}
                    userInfo={userInfo}
                    partnerId={partnerId}
                    kycNeeded={kycNeeded}
                />
            )}
        </div>
    );
};

FunnelRightContainer.propTypes = {
    partnerId: PropTypes.number,
    userInfo: PropTypes.object,
    userCart: PropTypes.array,
    stateOfTransaction: PropTypes.string,
    setStateOfTransaction: PropTypes.func,
    amountCashback: PropTypes.number,
    cartTotalValue: PropTypes.number,
    paymentType: PropTypes.string,
    kycNeeded: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(FunnelRightContainer);



// WEBPACK FOOTER //
// ./src/components/funnel/FunnelRightContainer.js